import React from 'react';
import {Link} from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiArrowRight} = FiIcons;

const ServicesCards = ({currentArea}) => {
  const handleLinkClick = () => {
    window.scrollTo({top: 0, behavior: 'smooth'});
  };

  // Format area name for URL (convert spaces to hyphens and lowercase)
  const formatAreaForUrl = (area) => {
    return area.toLowerCase().replace(/\s+/g, '-');
  };

  const areaUrlParam = formatAreaForUrl(currentArea);

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Our Professional Cleaning Services in {currentArea}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Comprehensive cleaning solutions for both commercial and domestic properties. Reliable, professional, and tailored to your needs.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
                    {/* Domestic Cleaning Card */}
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
            <div 
              className="h-64 bg-cover bg-center relative" 
              style={{backgroundImage: "url('/img/domestic-homepage.webp')"}}
            >
              <div className="absolute inset-0 bg-gradient-to-t from-green-900/80 to-green-600/20"></div>
              <div className="absolute bottom-4 left-4 text-white">
                <span className="bg-green-600 px-3 py-1 rounded-full text-sm font-semibold">Domestic</span>
              </div>
            </div>
            <div className="p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Domestic Cleaning Services</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                Keep your home spotless with our reliable domestic cleaning services. From regular weekly cleans to one-off deep cleans and end-of-tenancy services - we make your home shine.
              </p>
              
              <div className="grid grid-cols-2 gap-3 mb-6 text-sm">
                <div className="flex items-center space-x-2">
                  <div className="w-2 h-2 bg-green-600 rounded-full"></div>
                  <span className="text-gray-700">Regular Home Cleaning</span>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="w-2 h-2 bg-green-600 rounded-full"></div>
                  <span className="text-gray-700">Deep Cleaning</span>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="w-2 h-2 bg-green-600 rounded-full"></div>
                  <span className="text-gray-700">End of Tenancy</span>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="w-2 h-2 bg-green-600 rounded-full"></div>
                  <span className="text-gray-700">Move In/Out Cleans</span>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="w-2 h-2 bg-green-600 rounded-full"></div>
                  <span className="text-gray-700">Oven & Appliance Cleaning</span>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="w-2 h-2 bg-green-600 rounded-full"></div>
                  <span className="text-gray-700">Carpet Cleaning</span>
                </div>
              </div>

              <div className="bg-green-50 rounded-lg p-4 mb-6">
                <p className="text-green-800 text-sm font-medium">
                  🏠 <strong>Trusted by families:</strong> Fully vetted cleaners, flexible scheduling, and we bring all supplies. Your home is in safe hands.
                </p>
              </div>

              <Link 
                to={`/domestic/${areaUrlParam}`} 
                className="inline-flex items-center space-x-2 text-green-600 hover:text-green-700 font-semibold text-lg group transition-colors"
                onClick={handleLinkClick}
              >
                <span>Explore Domestic Services</span>
                <SafeIcon icon={FiArrowRight} className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Link>
            </div>
          </div>
          
          {/* Commercial Cleaning Card */}
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
            <div 
              className="h-64 bg-cover bg-center relative" 
              style={{backgroundImage: "url('/img/communal-cleaning.webp')"}}
            >
              <div className="absolute inset-0 bg-gradient-to-t from-blue-900/80 to-blue-600/20"></div>
              <div className="absolute bottom-4 left-4 text-white">
                <span className="bg-blue-600 px-3 py-1 rounded-full text-sm font-semibold">Commercial</span>
              </div>
            </div>
            <div className="p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Commercial Cleaning Services</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                Professional commercial cleaning for businesses of all sizes. From office buildings and retail spaces to restaurants and communal areas - we maintain the highest standards for your professional environment.
              </p>
              
              <div className="grid grid-cols-2 gap-3 mb-6 text-sm">
                <div className="flex items-center space-x-2">
                  <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
                  <span className="text-gray-700">Office Buildings</span>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
                  <span className="text-gray-700">Retail Spaces</span>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
                  <span className="text-gray-700">Communal Areas</span>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
                  <span className="text-gray-700">Restaurants & Bars</span>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
                  <span className="text-gray-700">Retirement Properties</span>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
                  <span className="text-gray-700">Educational Facilities</span>
                </div>
              </div>

              <div className="bg-blue-50 rounded-lg p-4 mb-6">
                <p className="text-blue-800 text-sm font-medium">
                  ⭐ <strong>Why businesses choose us:</strong> Flexible scheduling, fully insured team, and consistent quality that maintains your professional image.
                </p>
              </div>

              <Link 
                to={`/commercial/${areaUrlParam}`} 
                className="inline-flex items-center space-x-2 text-blue-600 hover:text-blue-700 font-semibold text-lg group transition-colors"
                onClick={handleLinkClick}
              >
                <span>Explore Commercial Services</span>
                <SafeIcon icon={FiArrowRight} className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Link>
            </div>
          </div>
        </div>

        {/* Popular Services Links */}
        <div className="mt-20">
          <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">
            Most Popular Services in {currentArea}
          </h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <Link 
              to={currentArea === 'Aylesbury' ? '/deep-cleaning' : `/deep-cleaning/${areaUrlParam}`} 
              className="group bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 text-center border-2 border-transparent hover:border-blue-200"
              onClick={handleLinkClick}
            >
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-blue-200 transition-colors">
                <span className="text-2xl">✨</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2 text-lg">Deep Cleaning</h4>
              <p className="text-gray-600 text-sm mb-4">Comprehensive home refresh that goes beyond regular cleaning</p>
              <span className="text-blue-600 font-medium text-sm group-hover:text-blue-700">Learn More →</span>
            </Link>

            <Link 
              to={currentArea === 'Aylesbury' ? '/end-of-tenancy' : `/end-of-tenancy/${areaUrlParam}`} 
              className="group bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 text-center border-2 border-transparent hover:border-green-200"
              onClick={handleLinkClick}
            >
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-green-200 transition-colors">
                <span className="text-2xl">🏠</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2 text-lg">End of Tenancy</h4>
              <p className="text-gray-600 text-sm mb-4">Deposit back guarantee with professional move-out cleaning</p>
              <span className="text-green-600 font-medium text-sm group-hover:text-green-700">Learn More →</span>
            </Link>

            <Link 
              to={currentArea === 'Aylesbury' ? '/office-cleaning' : `/office-cleaning/${areaUrlParam}`} 
              className="group bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 text-center border-2 border-transparent hover:border-purple-200"
              onClick={handleLinkClick}
            >
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-purple-200 transition-colors">
                <span className="text-2xl">🏢</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2 text-lg">Office Cleaning</h4>
              <p className="text-gray-600 text-sm mb-4">Professional workspace maintenance for productive environments</p>
              <span className="text-purple-600 font-medium text-sm group-hover:text-purple-700">Learn More →</span>
            </Link>

            <Link 
              to={currentArea === 'Aylesbury' ? '/communal-cleaning' : `/communal-cleaning/${areaUrlParam}`} 
              className="group bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 text-center border-2 border-transparent hover:border-orange-200"
              onClick={handleLinkClick}
            >
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-orange-200 transition-colors">
                <span className="text-2xl">🏘️</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2 text-lg">Communal Cleaning</h4>
              <p className="text-gray-600 text-sm mb-4">Apartment buildings and retirement property maintenance</p>
              <span className="text-orange-600 font-medium text-sm group-hover:text-orange-700">Learn More →</span>
            </Link>
          </div>
        </div>

        {/* Call to Action */}
        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-blue-600 to-green-600 rounded-2xl p-8 text-white">
            <h3 className="text-2xl font-bold mb-4">
              Ready to Experience Professional Cleaning?
            </h3>
            <p className="text-blue-100 mb-6 max-w-2xl mx-auto">
              Join hundreds of satisfied customers in {currentArea} who trust Diamond Cleaning for their domestic and commercial cleaning needs.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link 
                to="/book" 
                className="bg-white text-blue-600 px-8 py-3 rounded-lg hover:bg-gray-100 transition-colors font-semibold flex items-center justify-center space-x-2"
                onClick={handleLinkClick}
              >
                <span>Book Online Now</span>
              </Link>
              <a 
                href="tel:07878522378" 
                className="bg-green-600 text-white px-8 py-3 rounded-lg hover:bg-green-700 transition-colors font-semibold border-2 border-white flex items-center justify-center space-x-2"
              >
                <span>Call: 07878 522378</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesCards;